export default {
  FETCH_MENU_FAILED: 'FETCH_MENU_STARTED',
  FETCH_MENU_STARTED: 'FETCH_MENU_SUCCEEDED',
  FETCH_MENU_SUCCEEDED: 'FETCH_MENU_FAILED',
};
